import { Tag, Check } from "lucide-react";
import { useT } from "../../i18n/LanguageContext";

export default function BannerPreco() {
  const { t } = useT();
  return (
    <section
      className="py-16 md:py-20 relative overflow-hidden"
      style={{ background: "linear-gradient(135deg, #d6a138 0%, #c89033 100%)" }}
      data-testid="banner-preco"
    >
      <div className="absolute inset-0 opacity-15 pointer-events-none"
           style={{ backgroundImage: "radial-gradient(circle at 2px 2px, white 1px, transparent 1px)", backgroundSize: "32px 32px" }} />

      <div className="max-w-4xl mx-auto px-6 text-center text-white relative reveal">
        <div className="inline-flex items-center justify-center gap-3 font-display text-3xl sm:text-4xl md:text-5xl">
          <Tag size={32} className="opacity-80" />
          <h2 className="font-medium drop-shadow-sm">{t.bannerPreco.title}</h2>
        </div>
        <p className="mt-4 text-white/90 max-w-2xl mx-auto">{t.bannerPreco.subtitle}</p>

        <div className="mt-8 flex flex-wrap justify-center gap-3">
          {t.bannerPreco.bullets.map((b) => (
            <div
              key={b}
              className="flex items-center gap-2 bg-white/15 backdrop-blur px-4 py-2 rounded-full text-sm font-medium border border-white/20"
            >
              <span className="w-5 h-5 rounded bg-[#2e7d32] flex items-center justify-center">
                <Check size={12} strokeWidth={3} />
              </span>
              {b}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
